<div class="atlas-table t-ar">
  <action-button styleClass="atlas-btn-blue" [label]="'dashboard.revenue.reports.button-label' | translate | uppercase" [items]="menuItems">
  </action-button>
</div>
